// export const user_role = {
//   admin: 1,
//   vendor: 2,
//   deliveryman: 3,
//   customer: 4,
// };

// // Local
// const API_CONFIG_LOCAL = {
//   baseURL: "http://192.168.29.30:5000/api/v1/",
// };

// // live
// export const API_CONFIG_LIVE = {
//   baseURL: "https://edelivery.nablean.com/api/v1/",
// };

// const getServer = (isLive) => {
//   if (isLive) {
//     return API_CONFIG_LIVE.baseURL;
//   } else {
//     return API_CONFIG_LOCAL.baseURL;
//   }
// };

// const isLive = true;

// export const server = getServer(isLive);



export const user_role = {
  admin: 1,
  vendor: 2,
  deliveryman: 3,
  customer: 4,
};

const localUrl='http://192.168.1.24:5000'
const liveUrl='https://backend.edelivery.tech'
const deliveryLocalUrl='http://192.168.29.30:5001'
const deliveryLiveUrl='https://edeliveryapp.nablean.com'

const isLive = true;

export const serverUrl=isLive?liveUrl:localUrl;
export const server =isLive?`${liveUrl}/api/v1/`:`${localUrl}/api/v1/`
export const deliveryServer =isLive?`${deliveryLiveUrl}/api/v1/`:`${deliveryLocalUrl}/api/v1/`
